import React from 'react';

const DialogueTable = ({ lines }) => {
    return (
        <table className='dialogue-table'>
            <tbody>
                {lines.map(line => {
                    return (
                        <tr>
                            <td>{line[0]}</td>
                            <td>{line[1]}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    )
}

export default DialogueTable;